import { NewPasswordBody, resetPasswordApis } from '@apis/resetPasswordApis';
import { useMutation } from '@hooks/useMutation';
import { FormError } from '@utils/errors';

export const useResetPassword = () => {
  return useMutation(async (body: NewPasswordBody) => {
    const response = await resetPasswordApis.post('/password/reset/confirm/', { body });
    if (response[400]) {
      throw new FormError('RegistrationError', response[400]);
    }
    return response[200]!;
  });
};
